import { fetchLabelDetail, updateLabel } from '../api/labels';
import { changeReasonError, labelMetaOf, labelRevision, withLabelChange } from './labelTrace';

export async function saveLabelUpdate(id, payload, previous, reason) {
  const reasonError = changeReasonError(reason);
  if (reasonError) throw new Error(reasonError);
  const response = await fetchLabelDetail(id);
  const current = response?.data || response;
  if (!current || String(current.id ?? current.labelId) !== String(id)) throw new Error('无法核对当前标签，请重新打开后再试');
  if (labelRevision(previous) && labelRevision(current) && labelRevision(previous) !== labelRevision(current)) {
    throw new Error('此标签已在其他页面更新。请保留本次编辑内容，重新打开最新标签后再修改。');
  }
  const submitted = { ...payload, meta: withLabelChange({ ...labelMetaOf(current), ...payload.meta }, current, reason) };
  const result = await updateLabel(id, submitted);
  const returned = result?.data || result;
  const saved = returned && (returned.id || returned.labelId)
    ? { ...current, ...submitted, ...returned, meta: submitted.meta }
    : { ...current, ...submitted, updateTime: null, updatedAt: null };
  return { result, saved, meta: submitted.meta };
}
